<div class="cabinet-summary--container">
    <div class="flex-container gap-2 mb-4">
        <div class="flex-container justify-content-center p-2 cursor-pointer" (click)="goBack()">
            <img class="back-arrow" src="../../../assets/images/back_arrow.png" alt="" srcset="">
        </div>
        <div>
            <h2 class="header-2 text-start">{{ cabinetDetails.u_name }} - Access summary</h2>
        </div>
    </div>

    <div *ngIf="isCabinetProductSummary" class="table-container">
        <div class="table-top-wrapper">
            <div class="flex-container gap-2">
                <h2 class="header-2">Entries: {{ totalProducts }}</h2>
            </div>
            <div class="search-controls">
                <form action="" class="search-block" (submit)="onSearchSubmit()">
                    <div class="search-input">
                        <input type="text" [(ngModel)]="searchInput" name="search" placeholder="Search by Product name and batch number">
                    </div>
                    <button type="submit" class="icon-btn">
                        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M15.2513 12.9228L16.8527 14.5242C17.4953 15.1668 17.4953 16.2086 16.8527 16.8512C16.2101 17.4938 15.1683 17.4938 14.5257 16.8512L12.9243 15.2498M0.667969 7.74984C0.667969 3.83782 3.83929 0.666504 7.7513 0.666504C11.6633 0.666504 14.8346 3.83782 14.8346 7.74984C14.8346 11.6619 11.6633 14.8332 7.7513 14.8332C3.83929 14.8332 0.667969 11.6619 0.667969 7.74984Z" stroke="white" stroke-width="1.25" stroke-linecap="round"/>
                        </svg>                            
                    </button>
                </form>
                <button type="button" class="reset-btn" (click)="reset($event)">
                    Reset
                </button>
            </div>
        </div>

        <div class="table-wrapper table-responsive">
            <table class="table">
                <thead>
                    <tr>
                        <th class="" scope="col">RFID</th>
                        <th class="" scope="col">Product name</th>
                        <th class="" scope="col">Batch Number</th>
                        <th class="position-relative" scope="col">
                            Username
                            <span (click)="openUsersPopup($event)">
                                <img *ngIf="selectedUserNames.length === 0" class="sort-img" src="../../../../assets/images/dropdown.png" alt="">
                                <img *ngIf="selectedUserNames.length !== 0" class="ms-1" src="../../../assets/images/check.svg" alt="" srcset="">
                            </span>
                            <div class="popup" id="users-popup">
                                <form>
                                    <div class="form-group" *ngFor="let user of userNamesList">
                                      <input name="user" [id]="user.first_name" type="checkbox" [value]="user.id" [checked]="selectedUserNames.includes(user.id.toString()) ? true : false" (change)="onUserFilterChange($event)">
                                      <label [for]="user.first_name">{{ user.first_name+ " " + user.last_name }}</label>
                                    </div>
                                </form> 
                            </div> 
                        </th>
                        <th class="" scope="col">
                            Logged at
                            <span (click)="loggedAtSort()">
                                <img class="sort-img" src="../../../assets/images/table/sort.png" alt="sort">
                            </span>
                        </th>
                        <th class="position-relative" scope="col">
                            Action
                            <span class="" id="action-popup--trigger" (click)="openActionPopup($event)">
                                <img *ngIf="selectedActions.length === 0" src="../../../assets/images/dropdown.png" alt="" srcset="">
                                <img *ngIf="selectedActions.length !== 0" class="ms-1" src="../../../assets/images/check.svg" alt="" srcset="">
                            </span>
                            <div class="popup" id="action-popup">
                                <form>
                                    <div class="form-group">
                                      <input name="action" type="checkbox" value="in" [checked]="selectedActions.includes('in') ? true : false" (change)="onActionFilterChange($event)" id="in">
                                      <label for="in">In</label>
                                    </div>
                                    <div class="form-group">
                                      <input name="action" type="checkbox" value="out" [checked]="selectedActions.includes('out') ? true : false" (change)="onActionFilterChange($event)" id="out">
                                      <label for="out">Out</label>
                                    </div>
                                </form>
                            </div> 
                        </th>
                    </tr>
                </thead>
                <tbody *ngIf="isFilterResult">
                    <tr *ngFor="let product of cabinetProductSummary">
                        <th>{{ product.rfid }}</th>
                        <td>{{ product.product_name }}</td>
                        <td>{{ product.batch_no }}</td>
                        <td>{{ product.first_name +" "+ product.last_name }}</td>
                        <td>{{ product.logged_at }}</td>
                        <td>{{ product.action.charAt(0).toUpperCase() + product.action.slice(1) }}</td>
                    </tr>
                </tbody>
                <tbody *ngIf="!isFilterResult">
                    <td colspan="6">
                        <div class="p-3 no-record text-center flex-container flex-column justify-content-center">
                            <img src="../../../assets/images/table/filter_empty_screen.svg" alt="" srcset="">
                            <h2 class="header-2 mb-2">No records were found matching your search</h2>
                        </div>
                    </td>
                </tbody>
            </table>
        </div>

        <div class="" *ngIf="totalPages > 1 && isCabinetProductSummary">
            <app-pagination [totalPages]="totalPages" (queryPage)="getQueryPage($event)"></app-pagination>
        </div>
    </div>
    <div *ngIf="!isCabinetProductSummary" class="p-3 no-record text-center flex-container flex-column justify-content-center">
        <img src="../../../assets/images/table/empty_cabinet_summary.svg" alt="" srcset="">
        <h2 class="header-2 mb-2">No records available to view</h2>
        <p class="text-xs text-light-dark">The access summary of products within this cabinet can be viewed here</p>
    </div>
</div>
